import React, { useEffect, useState } from 'react';
import { Line } from "react-chartjs-2";
import {
 Chart,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Tooltip,
 Legend,
} from "chart.js";

Chart.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend);

const StockTakeStatisticsChart = ({ sales }) => {
 const [sales_data, setSalesData] = useState(sales);

 useEffect(() => {
  setSalesData(sales);
 }, [sales]);

 const addData = sales_data?.add_adjustment_type || [];
 const subtractData = sales_data?.subtract_adjustment_type || [];

 // 1. Create a sorted union of all dates
 const allDatesSet = new Set([
  ...addData.map(s => s.date),
  ...subtractData.map(s => s.date)
 ]);
 const allDates = Array.from(allDatesSet).sort();

 // 2. Helper to map values by date
 const mapByDate = (dataArray) => {
  const map = {};
  dataArray.forEach(s => {
   map[s.date] = s.units;
  });

  // Map allDates to units or 0/null
  return allDates.map(date => map[date] ?? 0);
 };

 const data = {
  labels: allDates,
  datasets: [
   {
    label: "Stock In",
    data: mapByDate(addData),
    borderColor: "#2596be",
    backgroundColor: "rgba(0, 153, 255, 0.1)",
    fill: true,
    tension: 0.4
   },
   {
    label: "Stock Out",
    data: mapByDate(subtractData),
    borderColor: "#eb6459",
    backgroundColor: "rgba(241, 81, 66, 0.1)",
    fill: true,
    tension: 0.4
   }
  ]
 };

 return (
  <Line
   data={data}
   options={{
    plugins: {
     legend: { display: true },
     tooltip: {
      enabled: true,
      callbacks: {
       label: function (context) {
        return context.parsed.y;
       },
      },
     },
    },
    maintainAspectRatio: false,
    scales: {
     y: {
      beginAtZero: true,
      ticks: { color: "#9eaecf", font: { size: 11 }, padding: 10 },
      grid: { color: "rgba(82, 100, 132, 0.2)" }
     },
     x: {
      ticks: { color: "#9eaecf", font: { size: 9 }, padding: 10 },
      grid: { color: "transparent" }
     },
    },
   }}
  />
 );
};

export default StockTakeStatisticsChart;
